<template>
  <!-- 用户中心页 /user -->
  <div>
    <img class="bg" src="@/assets/dashboard/bg.webp" />
    <Header />
    <div class="content">
      <TitleBar title="个人信息" />
      <!-- 基础信息 -->
      <div class="card flex-between">
        <el-descriptions title="基础信息" :column="4">
          <el-descriptions-item label="姓名">{{ user.name }}</el-descriptions-item>
          <el-descriptions-item label="工号">{{ user.code }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{
            user.gender == 1 ? "男" : user.gender == 2 ? "女" : "未知"
          }}</el-descriptions-item>
          <el-descriptions-item label="手机号">
            <span> {{ user.phone }} </span>
            <el-button type="text" style="padding: 0 8px" @click="dialogName = 'phone'">
              <i class="el-icon-edit" />
            </el-button>
          </el-descriptions-item>
          <el-descriptions-item label="企业" :span="1"
            >{{ user.companyName }}
          </el-descriptions-item>
          <el-descriptions-item label="岗位" :span="3">
            <el-tag
              v-for="job in user.job"
              :key="job.name"
              type="info"
              size="mini"
              style="margin-right: 8px"
              >{{ job.name }}</el-tag
            >
          </el-descriptions-item>
        </el-descriptions>
        <div class="avatar" @click="dialogName = 'avatar'">
          <div v-if="!user.avatar" class="name">
            {{ user.name ? user.name.slice(-2) : "" }}
          </div>
          <img v-else :src="user.avatar" />
        </div>
      </div>

      <!-- 账号安全 -->
      <div class="card">
        <div class="N1 font16 bold">账号安全</div>
        <div class="flex">
          <!-- 微信绑定 -->
          <div
            class="app-action wechat active"
            :class="{ gray: user.isBindWx != 1 }"
            @click="onClickBindBtn('wechat', 'isBindWx')"
          >
            <div class="action-circle">
              <img class="action-svg" src="@/svg/wechat.svg" alt="微信" />
            </div>
            <div class="G1 font12">
              {{ user.isBindWx == 1 ? "已绑定微信" : "绑定微信" }}
            </div>
          </div>

          <!-- 钉钉绑定 -->
          <div
            class="app-action dingtalk active"
            :class="{ gray: user.isBindDingtalk != 1 }"
            @click="onClickBindBtn('dingtalk', 'isBindDingtalk')"
          >
            <div class="action-circle">
              <img class="action-svg" src="@/svg/dingtalk.svg" alt="钉钉" />
            </div>
            <div class="blue font12">
              {{ user.isBindDingtalk == 1 ? "已绑定钉钉" : "绑定钉钉" }}
            </div>
          </div>

          <!-- 授权码 -->
          <div
            class="app-action alipay active"
            :class="{ gray: !hasAuthCode }"
            @click="dialogName = 'alipay'"
          >
            <div class="action-circle">
              <img class="action-svg" src="@/svg/alipay.svg" alt="授权码" />
            </div>
            <div class="Y4 font12">{{ hasAuthCode ? "授权码生效中" : "授权码" }}</div>
          </div>

          <!-- 修改密码 -->
          <div class="app-action active" @click="dialogName = 'password'">
            <img class="action-icon" src="@/assets/login/password.png" alt="修改密码" />
            <div class="blue font12">修改密码</div>
          </div>
        </div>
      </div>

      <!-- 门店信息 -->
      <div class="card">
        <div class="N1 font16 bold">门店信息</div>
        <div class="padding8"></div>
        <el-table :data="user.hotel" stripe :header-cell-style="{ background: '#f2f3f5' }">
          <el-table-column prop="name" label="门店名称" width="350" />
          <el-table-column prop="code" label="编号" />
          <el-table-column prop="areaName" label="区域" />
          <el-table-column prop="brandName" label="品牌" />
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.state == 100" size="small" type="success">营业中</el-tag>
              <el-tag v-else-if="scope.row.state == 110" size="small">未开业</el-tag>
              <el-tag v-else-if="scope.row.state == 150" size="small" type="warning"
                >暂停营业</el-tag
              >
              <el-tag v-else-if="scope.row.state == 200" size="small" type="info"
                >系统已过期</el-tag
              >
              <el-tag v-else-if="scope.row.state == 250" size="small" type="danger">已停业</el-tag>
              <el-tag v-else type="info" size="small">异常</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="padding16"></div>

    <!-- 修改手机号弹框 -->
    <DialogPhone :visible="dialogName == 'phone'" @hide="dialogName = null" />
    <!-- 修改头像弹框 -->
    <DialogAvatar
      :visible="dialogName == 'avatar'"
      @hide="dialogName = null"
      @update="onAvatarChange"
    />
    <!-- 修改密码弹框 -->
    <DialogPassword :visible="dialogName == 'password'" @hide="dialogName = null" />
    <!-- 授权码弹框 -->
    <DialogAlipay
      :visible="dialogName == 'alipay'"
      :authorization-code="authorizationCode"
      @hide="dialogName = null"
      @update="onAuthCodeChange"
    />
    <!-- 绑定微信弹框 -->
    <DialogWeChatScan
      :visible="dialogName == 'wechat'"
      @hide="dialogName = null"
      @update="onBindSuccess('isBindWx', $event)"
    />
    <!-- 绑定钉钉弹框 -->
    <DialogDingtalkScan
      :visible="dialogName == 'dingtalk'"
      @hide="dialogName = null"
      @update="onBindSuccess('isBindDingtalk')"
    />
  </div>
</template>

<script>
import Header from "@/components/Header";
import TitleBar from "@/components/TitleBar";
import DialogPhone from "./components/DialogPhone";
import DialogPassword from "./components/DialogPassword";
import DialogAvatar from "./components/DialogAvatar";
import DialogWeChatScan from "./components/DialogWeChatScan";
import DialogDingtalkScan from "./components/DialogDingtalkScan";
import DialogAlipay from "./components/DialogAlipay";

export default {
  name: "UserProfile",
  components: {
    Header,
    TitleBar,
    DialogPhone,
    DialogPassword,
    DialogWeChatScan,
    DialogAvatar,
    DialogAlipay,
    DialogDingtalkScan,
  },
  data() {
    return {
      dialogName: null,
      hasAuthCode: false, // 是否有授权码（控制入口是否置灰）
      authorizationCode: "", // 当前授权码
      user: JSON.parse(localStorage.user || "{}"),
    };
  },
  mounted() {
    this.loadAuthCode();
  },
  methods: {
    /**
     * 进入页面时获取授权码，判断入口是否置灰
     */
    async loadAuthCode() {
      const [res, err] = await this.$get("getAuthorizationCode");
      if (err) return this.$msg(err);
      this.authorizationCode = (res && res.authorizationCode) || "";
      this.hasAuthCode = !!this.authorizationCode;
    },

    /**
     * 授权码弹框状态同步（传入最新授权码，空串表示已停用）
     * @param {string} code - 最新授权码
     */
    onAuthCodeChange(code) {
      this.authorizationCode = code || "";
      this.hasAuthCode = !!this.authorizationCode;
    },

    /**
     * 更新用户头像
     * @param {string} img - 新头像图片地址
     */
    onAvatarChange(img) {
      this.user.avatar = img;
      localStorage.setItem("user", JSON.stringify(this.user));
    },

    /**
     * 点击平台绑定/解绑
     * @param {string} platform - 平台标识
     * @param {string} key - 绑定的状态字段
     */
    onClickBindBtn(platform, key) {
      const bindObj = { wechat: "微信", dingtalk: "钉钉" };
      if (this.user[key] != 1) return (this.dialogName = platform);
      this.$msgbox
        .confirm(`您已经绑定过${bindObj[platform]}账号。`, "", {
          confirmButtonText: "确 定",
          cancelButtonText: "解 绑",
          customClass: "prompt-plus",
          type: "success",
        })
        .then()
        .catch(() => this.unbindThirdPartyAccount(platform, key));
    },

    /**
     * 解绑第三方账号
     * @param {string} platform - 平台名称
     * @param {string} key - 用户数据对应字段
     */
    async unbindThirdPartyAccount(platform, key) {
      const [res, err] = await this.$post("unbindThirdPartyAccount", {
        platform,
      });
      if (err) return this.$msg(err);
      this.user[key] = 2;
      localStorage.setItem("user", JSON.stringify(this.user));
    },

    /**
     * 第三方绑定成功回调
     * @param {string} key - 用户数据对应字段
     * @param {Object} [user] - 扫码后刷新的最新用户信息(透传自弹窗)
     */
    onBindSuccess(key, user) {
      if (user) this.user = user; // 使用最新用户信息, 避免本地旧快照覆写缓存
      this.user[key] = 1;
      localStorage.setItem("user", JSON.stringify(this.user));
    },
  },
};
</script>

<style scoped>
@import "../../styles/dashboard-bg.scss";

.content {
  margin: 0 auto;
  padding: 0 24px;
  width: 1200px;
}

.card {
  background-color: #fff;
  text-align: left;
  margin: 24px 0;
  padding: 24px;
  border-radius: 8px;
}

.avatar {
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  font-size: 40px;
  text-align: center;
  color: #dcdee0;
  background-color: #ebedf0;
  overflow: hidden;
  margin-top: 40px;
  min-width: 96px;
  max-width: 96px;
  height: 96px;
  line-height: 96px;
}

.avatar .name {
  line-height: 104px;
}

.avatar img {
  width: 96px;
  height: 96px;
  object-fit: cover;
}

.avatar::after {
  z-index: 1;
  position: absolute;
  left: 0;
  content: "更换头像";
  opacity: 0;
  background: #00000055;
  text-align: center;
  width: 96px;
  line-height: 96px;
  font-size: 12px;
  font-weight: 800;
  color: #fff;
  transition: all 0.3s;
}

.avatar:hover::after {
  opacity: 1;
}

.app-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;
  width: 80px;
  transition: all 0.2s;
}

.active:hover {
  cursor: pointer;
}

/* 圆形图标容器:背景色 = 文字颜色,禁用时灰色 */
.action-circle {
  width: 56px;
  height: 56px;
  margin: 24px 0 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-circle .action-svg {
  width: 32px;
  height: 32px;
}

.wechat .action-circle {
  background-color: #67c23a;
}

.dingtalk .action-circle {
  background-color: #00a1ff;
}

.alipay .action-circle {
  background-color: #e7a447;
}

.gray .action-circle {
  background-color: #babdc6;
}

.gray .font12 {
  color: #878b96;
}

/* 统一的账号安全操作图标样式(修改密码保留原图) */
.action-icon {
  width: 56px;
  height: 56px;
  margin: 24px 0 12px;
  object-fit: contain;
  border-radius: 50%;
}
</style>
